import { render, staticRenderFns } from "./newmembers.vue?vue&type=template&id=158e7abf&scoped=true&"
import script from "./newmembers.js?vue&type=script&lang=js&"
export * from "./newmembers.js?vue&type=script&lang=js&"
import style0 from "./newmembers.vue?vue&type=style&index=0&id=158e7abf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158e7abf",
  null
  
)

export default component.exports